<template>
    <el-dialog @close='closeDialog' :title="title" custom-class='QuestionbankTypePopu' :visible.sync="dialogVisible">
        <div class="questionbank_pop_box">
             <template v-if="!treeData || treeData.length <= 0 || treeData == []">
                <div class="null" style="margin-top: 30px">
                    <img :src="require('@/common/images/other/zwsj@2x.png')" alt="" style="width: 300px; height: auto; margin-top: 0;">
                    <span style="font-size: 16px">当前暂无新建分类</span>
                </div>
            </template>
            <!-- end 列表为空 -->
            <template v-else>
                <el-tree :data="treeData" node-key="id" :default-expand-all="true" :expand-on-click-node="true" :highlight-current="true" @node-click="clickTree">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                        <span class="datacount">{{data.datacount}}</span>
                    </span>
                </el-tree>
            </template>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="sureBtn()">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
// import {findGoodsList, addGoods} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {getAllHostcatalog,} from 'api/questionApi'
import $ from 'jquery'
export default {
    name: 'QuestionbankTypePopu',
    props: ['type'],
    data() {
        return {
            dialogVisible: false,
            treeData: [],   // 树参数
            title: '',  // 弹窗标题
            clickTtem: {}  // 选择事件
        }
    },
    mounted() {
    },
    methods: {
        // 打开弹窗
        openDialog(title) {
            this._initTree()
            this.title = title
            this.dialogVisible = true
        },
        // 关闭弹框
        closeDialog() {
            this.dialogVisible = false
        },
        clickTree(data) {   // 树点击事件
            // console.log(data)
            this.clickTtem = data
        },
        // 确定按钮
        sureBtn() {
            // 返回数据给父组件
            this.$emit('returnFatherData', JSON.stringify(this.clickTtem))
        },
        _initTree() {   // 初始化树
            this.setLoading(true)
            getAllHostcatalog({
                data: {
                    catetype: this.type == undefined ? 1 : this.type,    // 	题库分类类型： 1试题分类 2试卷分类
                    showdefault: 1 // 是否显示未分类：0否 1是
                },
                success: data => {
                    this.setLoading(false)
                    this.treeData = data.data.children
                },
                error: data => {
                    this.$message.error(data.msg)
                    this.setLoading(false)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scope>
.QuestionbankTypePopu {
    .questionbank_pop_box {
        height: 280px;
        overflow: auto;
        .el-tree-node__content {
            height: 40px;
        }
    }
    .questionbank_pop_box::-webkit-scrollbar {
        width: 4px;
    }
    .questionbank_pop_box::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background:rgba(229,229,229,1);
    }
    .questionbank_pop_box::-webkit-scrollbar-track {
        border-radius: 2px;
        background: #fff;
    }

    .datacount {
            margin-left: 12px;
            font-size: 12px;
            color: #909399;
        }
    .custom-tree-node {
        padding-right: 24px;
        width: 100%;
        font-size: 14px;
        line-height: 32px;

        // span:last-child {
            // display: block;
            // float: left;
        // }
    }
    .el-tree {
        margin-top: 0;
        border: none;
    }
    .null {
        text-align: center;
        img {
            display: block;
            margin: auto;
            margin-top: 89px;
            width: 250px;
            // height: 269px;
        }
        span {
            font-size: 20px;
            text-align: center;
            color: #606266;
        }
    }


}
</style>
